module.exports = Em.Controller.extend({
    needs: ['organization', 'user'],

    activeOrganization: Em.computed.alias('controllers.user.activeOrganization')
})
